import {Card} from 'platform/components';
import {Box} from 'platform/foundation';
import {match} from 'ts-pattern';

import {useCallback} from 'react';

import {head, mergeAll} from 'ramda';
import {isArray} from 'ramda-adjunct';

import i18n from '@dms/i18n';
import {warehouseRoutes} from '@dms/routes';
import {DmsDataGrid, Section, catchUnhandledDataGridActions} from '@dms/shared';
import {useWarehouseParams} from '@dms/warehouse/shared-components';

import {composePath, suffixTestId, TestIdProps, useNavigate} from 'shared/web';

import type {ActionCallback, QueryFilterObject} from 'features/eag-grid';

interface IssueNotesProps extends TestIdProps {}

export function IssueNotes(props: IssueNotesProps) {
  const {serviceOrderIssueNoteId} = useWarehouseParams();
  const navigate = useNavigate();

  const actionCallback: ActionCallback = ({actionKey, rowId}) => {
    const issueNoteId = isArray(rowId) ? head(rowId) : rowId;

    match(actionKey)
      .with('redirectDetail', () =>
        navigate(
          composePath(warehouseRoutes.issueNoteDetailOverview, {
            params: {id: issueNoteId},
          })
        )
      )
      .otherwise(() => catchUnhandledDataGridActions(actionKey));
  };

  const queryModifier = useCallback(
    (filter: QueryFilterObject) => mergeAll([filter, {originDocId: serviceOrderIssueNoteId}]),
    [serviceOrderIssueNoteId]
  );

  return (
    <Section data-testid={suffixTestId('wrapper', props)}>
      <Card title={i18n.t('page.warehouse.labels.issueNotes')}>
        <Box height="65vh">
          <DmsDataGrid
            gridCode="issue-notes-service-order-issue-note"
            emptyState={{headline: i18n.t('general.labels.noData')}}
            actionCallback={actionCallback}
            queryModifier={queryModifier}
            data-testid="issue-notes-service-order-issue-note"
          />
        </Box>
      </Card>
    </Section>
  );
}
